import React, { useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import { useModal } from '../context/ModalContext';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.marrycenter.app';

/* Official-style Google Play colorful triangle logo */
const GooglePlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 28" width="34" height="38" aria-hidden="true">
    <path d="M0.4 0.9C0.15 1.18 0 1.59 0 2.08V25.9c0 .49.15.9.4 1.18L.5 27.2 13.18 14.5v-.3L.5.78z" fill="#00D4EA" />
    <path d="M17.3 18.68l-4.12-4.18V14.2l4.12-4.18.1.06 4.87 2.77c1.39.79 1.39 2.08 0 2.87l-4.87 2.77z" fill="#FFD400" />
    <path d="M17.4 18.62L13.18 14.4.4 27.08c.46.49 1.21.55 2.06.06l14.94-8.52z" fill="#FF3B30" />
    <path d="M.4 0.9L17.4 9.38l-4.22 4.22L0.4 0.9z" fill="#00E676" />
  </svg>
);

const CTA = () => {
  const { openSignup } = useModal();
  const [isOpening, setIsOpening] = useState(false);

  const handleDownload = () => {
    if (isOpening) return;
    setIsOpening(true);
    window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
    setTimeout(() => setIsOpening(false), 2500);
  };

  return (
    <section className="relative py-24 overflow-hidden border-t border-white/5">
      {/* Background Gradient & Effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#000000] via-[#050508] to-[#000000] z-0"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="animate-fade-in-up">
          <FaHeart className="text-pink-400 text-5xl mx-auto mb-6 animate-pulse drop-shadow-xl" />
          
          <h2 className="text-4xl lg:text-5xl font-romantic font-extrabold text-white mb-6 drop-shadow-md">
            Ready to Find Your Soulmate?
          </h2>

          <p className="text-xl text-pink-100 mb-10 max-w-2xl mx-auto leading-relaxed drop-shadow">
            Join thousands of singles who have found their perfect match.
            Your journey to forever starts with a single click.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center flex-wrap">
            <button
              onClick={() => openSignup()}
              className="px-8 py-4 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-full font-bold text-lg hover:from-pink-600 hover:to-rose-600 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 shadow-[0_10px_30px_rgba(236,72,153,0.3)] flex items-center justify-center group"
            >
              <FaHeart className="mr-2 text-white group-hover:scale-125 transition-transform" />
              Create Your Profile - It's Free
            </button>

            {/* Official-style Play Store Badge Button */}
            <button
              onClick={handleDownload}
              disabled={isOpening}
              aria-label="Download MarryCenter on Google Play"
              className="playstore-btn-romantic group hover:-translate-y-1 hover:scale-105"
            >
              {isOpening ? (
                <span className="playstore-btn-spinner border-slate-500 border-t-pink-500" />
              ) : (
                <div className="transform group-hover:scale-110 transition-transform duration-300">
                  <GooglePlayIcon />
                </div>
              )}
              <span className="playstore-btn-inner text-left">
                <span className="playstore-btn-sub text-slate-400">
                  {isOpening ? 'Opening…' : 'Google Play Store'}
                </span>
                <span className="playstore-btn-main text-white group-hover:text-pink-400 transition-colors">
                  Download
                </span>
              </span>
            </button>
          </div>

          <p className="text-white/60 text-sm mt-8 font-medium tracking-wide">
            No credit card required • 30-second signup • 100% free to start
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;